export type FlightStatus = "ready" | "running" | "paused" | "gameover";

export interface FlightSnapshot {
  status: FlightStatus;
  score: number;
  best: number;
  canSubmit: boolean;
}

export class FlightModel {
  private _status: FlightStatus = "ready";
  private _score = 0;
  private _best = Number(localStorage.getItem("snappybird:best") ?? 0);
  private submittedScore: number | null = null;

  get status() {
    return this._status;
  }

  get score() {
    return this._score;
  }

  get best() {
    return this._best;
  }

  get canSubmit() {
    return this._status === "gameover" && this._score > 0 && this.submittedScore !== this._score;
  }

  start() {
    this._score = 0;
    this._status = "running";
  }

  ready() {
    this._score = 0;
    this._status = "ready";
  }

  pause() {
    if (this._status === "running") {
      this._status = "paused";
    }
  }

  resume() {
    if (this._status === "paused") {
      this._status = "running";
    }
  }

  scorePipe() {
    if (this._status !== "running") {
      return;
    }

    this._score += 1;
    if (this._score > this._best) {
      this._best = this._score;
      localStorage.setItem("snappybird:best", String(this._best));
    }
  }

  end() {
    if (this._status === "gameover") {
      return;
    }

    this._status = "gameover";
  }

  markSubmitted() {
    this.submittedScore = this._score;
  }

  snapshot(): FlightSnapshot {
    return {
      status: this._status,
      score: this._score,
      best: this._best,
      canSubmit: this.canSubmit
    };
  }
}

export function dispatchFlightState(snapshot: FlightSnapshot) {
  window.dispatchEvent(new CustomEvent<FlightSnapshot>("snappybird:state", { detail: snapshot }));
}
